import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import Alpine from 'alpinejs';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initIntroCtaCards() {
  Alpine.data(
    'introCtaCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        document.addEventListener('DOMContentLoaded', () => {
          // @ts-ignore
          const swiperEl = this.$el.querySelector('.intro-card-swiper');
          if (swiperEl) {
            this.initSwiper(swiperEl as HTMLElement);
          }
        });
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          slidesPerView: 3,
          spaceBetween: 16,
          loop: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            992: {
              slidesPerView: 1,
            },
            1050: {
              slidesPerView: 1,
            },
            1200: {
              slidesPerView: 3,
            },
          },
        });
      },
    }),
  );
}
